import { AnimatePresence } from 'framer-motion';
import { useCallback, useEffect, useRef } from 'react';
import { LuX } from 'react-icons/lu';
import animations from '../../helpers/animations';
import { useModalAuthStore } from '../../store/auth/authModalStore';
import CheckEmailContent from './CheckEmailContent';
import LoginColumnContent from './LoginColumnContent';
import ResetPasswordContent from './ResetPasswordContent';
import SignUpColumnContent from './SignUpColumnContent';
import { AuthBackdrop, AuthContainer, AuthLeftColumn } from './styles';

export default function AuthModal() {
    const {
        isVisibleAuthModal: isOpen,
        setIsVisibleAuthModal: setIsOpen,
        page,
        setPage,
    } = useModalAuthStore();
    const modalRef = useRef<HTMLDivElement>(null);
    const shouldCloseOnPointerUpRef = useRef(false);

    const [currentColumn, setCurrentColumn] = [page, setPage];

    const handleKeyPress = useCallback(
        () => (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                setIsOpen(false);
            }
        },
        [setIsOpen]
    );

    const handlePopState = useCallback(() => {
        if (isOpen) {
            setIsOpen(false);
        }
    }, [isOpen, setIsOpen]);

    useEffect(() => {
        document.addEventListener('keydown', handleKeyPress);
        window.addEventListener('popstate', handlePopState);

        if (isOpen) document.body.style.overflow = 'hidden';
        else document.body.style.overflow = 'auto';

        return () => {
            document.removeEventListener('keydown', handleKeyPress);
            document.removeEventListener('popstate', handlePopState);
            document.body.style.overflow = 'auto';
        };
    }, [handleKeyPress, handlePopState, isOpen, setIsOpen]);

    return (
        <AnimatePresence>
            {isOpen && (
                <AuthBackdrop
                    {...animations.fadeInOut(0.1)}
                    onPointerDown={e => {
                        shouldCloseOnPointerUpRef.current =
                            e.button === 0 && e.target === e.currentTarget;
                    }}
                    onPointerUp={e => {
                        if (
                            shouldCloseOnPointerUpRef.current &&
                            e.target === e.currentTarget
                        ) {
                            setIsOpen(false);
                        }

                        shouldCloseOnPointerUpRef.current = false;
                    }}
                    onPointerCancel={() => {
                        shouldCloseOnPointerUpRef.current = false;
                    }}
                >
                    <AuthContainer
                        onClick={e => e.stopPropagation()}
                        ref={modalRef}
                    >
                        <button
                            className="close-modal-button"
                            onClick={() => setIsOpen(false)}
                        >
                            <LuX />
                        </button>
                        <div className="column-wrapper">
                            <AuthLeftColumn className="column">
                                <AnimatePresence mode="wait">
                                    {currentColumn === 'login' && (
                                        <LoginColumnContent
                                            setCurrentColumn={setCurrentColumn}
                                            setIsOpen={setIsOpen}
                                            key={'login'}
                                        />
                                    )}
                                    {currentColumn === 'signup' && (
                                        <SignUpColumnContent
                                            setCurrentColumn={setCurrentColumn}
                                            setIsOpen={setIsOpen}
                                            key={'signup'}
                                        />
                                    )}
                                    {currentColumn === 'reset-password' && (
                                        <ResetPasswordContent
                                            setCurrentColumn={setCurrentColumn}
                                            setIsOpen={setIsOpen}
                                            key={'reset-password'}
                                        />
                                    )}
                                    {currentColumn === 'email-submitted' && (
                                        <CheckEmailContent
                                            setCurrentColumn={setCurrentColumn}
                                            setIsOpen={setIsOpen}
                                            key={'email-submitted'}
                                        />
                                    )}
                                </AnimatePresence>
                            </AuthLeftColumn>
                        </div>
                        {/* <div className="column carousel-column">
                            <Carousel
                                customDelay={10_000}
                                images={[
                                    `/images/carousel/login-0.${i18n.language}.png`,
                                    `/images/carousel/login-1.${i18n.language}.png`,
                                    `/images/carousel/login-2.${i18n.language}.png`,
                                ]}
                            />
                        </div> */}
                    </AuthContainer>
                </AuthBackdrop>
            )}
        </AnimatePresence>
    );
}
